/* eslint no-underscore-dangle: [error, { allow: [_id] }] */
/* eslint react/no-danger: 'off' */
/* global globals, translations */
import React from 'react';
import get from 'lodash/get';

const PaymentSuccessSubscriptionOther = () => {
  const member = get(globals, 'subscriptionOtherMember', null);

  let thankYou = '';
  let adressAs = '';

  if (member) {
    thankYou = get(translations, 'txt: Paldies, ka uzdāvināji {:hostname} abonementu {:lietotajs}!', '')
      // .replace('{:hostname}', `<a href="/">${window.location.hostname}</a>`);
      .replace('{:hostname}', `<a href="/">${get(globals, 'currentDomainName', 'otrapuse.lv')}</a>`)
      .replace('{:lietotajs}', `<a href="/member/${member._id}">${member.name}</a>`);

    if (member.sex === 'M') {
      adressAs = `${get(translations, 'txt: viņš to novērtēs', '')}!`;
    } else if (member.sex === 'F') {
      adressAs = `${get(translations, 'txt: viņa to novērtēs', '')}!`;
    }
  }

  return (
    <div className="mtm">
      <div dangerouslySetInnerHTML={{ __html: thankYou }} />
      <div>
        {adressAs.charAt(0).toUpperCase() + adressAs.slice(1)}
      </div>
      <div className="mtm">
        <a href="/">{get(translations, 'txt: Sākums', '')}</a>
      </div>
    </div>
  );
};

export default PaymentSuccessSubscriptionOther;
